<template>
    <v-dialog v-model="show" :width="width">
        <v-card>
            <v-toolbar align="center" flat dense>
                <v-spacer/>
                <v-card-subtitle style="font-size: 16px;font-weight: bold">{{title}}</v-card-subtitle>
                <v-spacer/>
                <v-btn small icon>
                    <v-icon small @click="show=false">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider/>
            <v-card-text class="mt-4">
                <v-page-data-table
                        seq
                        dense
                        @dbClick="onSelectAndReturn"
                        @click="onSelect"
                        title=""
                        key-name="id"
                        :fields="tableFields"
                        ref="producer"
                        :show-edit="false"
                        hide-row-action
                        :query-api=queryApi>
                    <template v-slot:state="{item}">
                        {{item.state==0?'禁用':'启用'}}
                    </template>
                </v-page-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn tile color="primary" @click="onOk">确定</v-btn>
                <v-btn tile outlined @click="onCancel">取消
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        name: "LovDialog",
        props: {
            title: {
                type: String
            },
            value: {
                type: Boolean,
                default: false
            },
            fieldExp: {
                type: String
            },
            fields: {
                type: Array
            },
            width: {
                type: Number,
                default: 600
            },
            item: {},
            queryApi: {
                type: String
            }
        },
        watch: {
            value(val) {
                this.show = this.value;
            },
            show(val) {
                this.$emit('input', val);
            }
        },
        created() {
            this.show = this.value;
            if (!this.fields && this.fieldExp) {
                let exp = this.fieldExp.split(",");
                exp.forEach(item => {
                    let header = {};
                    let items = item.split("|");
                    header.name = items[0];
                    if (items.length > 1) {
                        header.value = items[1];
                    }
                    if (items.length > 2) {
                        header.width = items[2] + 'px';
                    }
                    if (items.length > 3) {
                        header.align = items[3];
                    }
                    header.id = "item." + header.value;
                    header.code = header.value;
                    this.tableFields.push(header);
                })
            } else {
                this.tableFields = this.fields;
            }
        },
        data() {
            return {
                show: null,
                selectedRow: null,
                tableFields: []
            }
        },
        methods: {
            onOk() {
                this.$emit('ok', this.selectedRow);
            },
            onCancel() {
                this.$emit('cancel');
            },
            onSelect(row) {
                this.selectedRow = row;
            },
            onSelectAndReturn(row) {
                this.$emit('ok', row.item);
            }
        }
    }
</script>
